import { metodologia } from "@/content";
import { Reveal, Overline } from "./Reveal";

export const Methodology = () => (
  <section id="metodologia" data-testid="methodology-section" className="relative scroll-mt-20 overflow-hidden py-20 md:py-28 lg:py-36">
    <div className="absolute left-1/2 top-1/2 h-[500px] w-[900px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-blue-700/10 blur-[140px]" />
    <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
      <Reveal className="max-w-2xl">
        <Overline>{metodologia.overline}</Overline>
        <h2 className="font-display mt-5 text-3xl font-semibold leading-tight tracking-tight text-white md:text-5xl">{metodologia.titulo}</h2>
        <p className="mt-6 text-base leading-relaxed text-slate-300 md:text-lg">{metodologia.descricao}</p>
      </Reveal>
      <div className="relative mt-12 md:mt-16 lg:mt-20">
        <div className="absolute left-0 right-0 top-[27px] hidden h-px bg-gradient-to-r from-cyan-300/60 via-blue-500/40 to-transparent lg:block" />
        <div className="relative grid gap-8 sm:grid-cols-2 sm:gap-10 lg:grid-cols-4 lg:gap-8">
          <div className="absolute bottom-6 left-[27px] top-6 w-px bg-gradient-to-b from-cyan-300/50 via-blue-500/30 to-transparent sm:hidden" />
          {metodologia.etapas.map((e, i) => (
            <Reveal key={e.numero} delay={i * 0.12}>
              <div data-testid={`methodology-step-${e.numero}`} className="group relative flex gap-5 sm:block">
                <div className="relative flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-cyan-300/30 bg-[#060d1f] font-mono text-sm text-cyan-300 shadow-[0_0_24px_rgba(34,211,238,0.2)] transition-[box-shadow] duration-300 group-hover:shadow-[0_0_36px_rgba(34,211,238,0.45)]">
                  {e.numero}
                </div>
                <div className="pt-3 sm:pt-0">
                  <h3 className="font-display text-xl font-semibold text-white sm:mt-8">{e.titulo}</h3>
                  <p className="mt-3 text-[15px] leading-7 text-slate-300 sm:text-base">{e.texto}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
